import { render, staticRenderFns } from "./LockScreenNfcBadgeEditModal.vue?vue&type=template&id=42bf4052"
import script from "./LockScreenNfcBadgeEditModal.vue?vue&type=script&lang=ts"
export * from "./LockScreenNfcBadgeEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42bf4052')) {
      api.createRecord('42bf4052', component.options)
    } else {
      api.reload('42bf4052', component.options)
    }
    module.hot.accept("./LockScreenNfcBadgeEditModal.vue?vue&type=template&id=42bf4052", function () {
      api.rerender('42bf4052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/LockScreenNfcBadgeEditModal.vue"
export default component.exports